@let items = (equipmentModelOptions | async) ?? [];

@if (label) {
  <lib-select
    [style.height.%]="100"
    [options]="items"
    [isOptionListLoading]="isLoading()"
    [isSearchDisplayed]="true"
    [searchTranslateKey]="searchTranslateKey"
    (scrolled)="loadMore()"
    (searchKeyChange)="onKeywordChange($event)"
    [formControl]="control"
    [label]="label"
    [fullWidth]="fullWidth"
  />
} @else {
  @if (labelTranslateKey) {
    <lib-select
      [style.height.%]="100"
      [options]="items"
      [isOptionListLoading]="isLoading()"
      [isSearchDisplayed]="true"
      [searchTranslateKey]="searchTranslateKey"
      (scrolled)="loadMore()"
      (searchKeyChange)="onKeywordChange($event)"
      [formControl]="control"
      [labelTranslateKey]="labelTranslateKey"
      [fullWidth]="fullWidth"
    />
  } @else {
    <lib-select
      [style.height.%]="100"
      [options]="items"
      [isOptionListLoading]="isLoading()"
      [isSearchDisplayed]="true"
      [searchTranslateKey]="searchTranslateKey"
      (scrolled)="loadMore()"
      (searchKeyChange)="onKeywordChange($event)"
      [formControl]="control"
      [fullWidth]="fullWidth"
    />
  }
}
